export default {
	methods: {
		async handle_update(new_content, old_content) {
			const overflow = new_content ? 'hidden' : '';

			document.body.style.overflow = overflow;
		},
	},
};
